export const version = {
  hash: 'd03c8e6e',
};
